import { Button, Form, Result } from 'antd';

import { useCreateNodeSupplierContract } from '../data';
import { NodeSupplierContractFormData, useNodeSupplierContractForm } from '../libs/use-node-supplier-contract-form';

export type CreateFormProps = {
  onCancel?: () => void;
};

export const CreateForm = (props: CreateFormProps) => {
  const create = useCreateNodeSupplierContract();

  const { getSuccessResultProps, getFormProps, getCreateAnotherButtonProps } = useNodeSupplierContractForm(
    create,
    props.onCancel,
  );

  const initialValues: NodeSupplierContractFormData = {
    contractName: '',
    contractNumber: '',
    intelSignedDate: new Date(),
  };

  return create.isSuccess ? (
    <Result
      {...getSuccessResultProps({ extra: [<Button {...getCreateAnotherButtonProps()} />] })}
      title="Successfully created a node supplier contract!"
    />
  ) : (
    <Form {...getFormProps('create')} initialValues={initialValues} />
  );
};
